<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-down' class='navbarbtn' v-if='showReleasePower'
        @click='batchRelease'>
        直接下推
      </el-button>

      <el-button type='danger' icon='sys sys-up' class='navbarbtn' v-if='showCancelReleasePower'
        @click='cancelBatchRelease'>
        撤销下推
      </el-button>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :expandRowKeys='mainTable.expandRowKeys'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='下推' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;' v-if='showReleasePower'
            @click='showICMOReleaseDialogMD(scope)'><i class='sys sys-down'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='撤销下推' placement='top-start'>
          <el-button type='danger' circle style='padding: 4px;' v-if='showCancelReleasePower'
            @click='cancelRelease(scope)'><i class='sys sys-up'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>工单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>计划开始</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>计划结束</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>计划设备</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>计划职员</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>实际开始</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>实际结束</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>实际设备</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>实际职员</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='icmoe in scope.data.row.detailDt1' :style='icmoEntrysRowStyle({ row: icmoe })'
            :key='icmoe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.EntryID}} </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.DetailNo}} </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.Qty}}{{icmoe.UnitName}} </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>
                {{!icmoe.PlanStartTime ? '' : dateTimeUtil.formartDateTime(new Date(icmoe.PlanStartTime), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>
                {{!icmoe.PlanEndTime ? '' : dateTimeUtil.formartDateTime(new Date(icmoe.PlanEndTime), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.PlanMachineNumber}} </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.PlanEmployeeName}} </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>
                {{!icmoe.StartTime ? '' : dateTimeUtil.formartDateTime(new Date(icmoe.StartTime), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>
                {{!icmoe.EndTime ? '' : dateTimeUtil.formartDateTime(new Date(icmoe.EndTime), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.MachineNumber}} </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='icmoe.LastRoutingFlag === "1" ? "color: blue;" : "color: red;"'>{{icmoe.EmployeeName}} </span>
            </div>
          </div>
        </div>
      </template>
    </Table>

    <!-- 工单下推 -->
    <el-dialog v-dialogDrag :title='"生产任务单【" + icmoRow.BillNo + "】工单下推"'
      :visible.sync='showICMOReleaseDialog' width='1080px' top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <el-table :data='icmoEntrys' border height='300px' key='DetailNo' ref='icmoEntrysTable'
          :cell-style='icmoEntrysCellStyle' :header-cell-style='icmoEntrysHeaderCellStyle'
          :row-style='icmoEntrysRowStyle' size='medium'>
          <el-table-column type='index' label='序号' width='60' fixed>
          </el-table-column>
          <el-table-column prop='DetailNo' label='工单号' width='140' fixed>
          </el-table-column>
          <el-table-column prop='ItemNumber' label='物料代码' width='160' fixed>
          </el-table-column>
          <el-table-column prop='ItemName' label='物料名称' width='250'>
          </el-table-column>
          <el-table-column prop='Qty' label='数量' width='110'>
            <template #default='scope'>
              {{scope.row.Qty}}
            </template>
          </el-table-column>
          <el-table-column prop='UnitName' label='单位' width='60'>
          </el-table-column>
          <el-table-column prop='PlanStartTime' label='计划开工日期' width='100'>
            <template #default='scope'>
              {{scope.row.PlanStartTime ? dateTimeUtil.formartDateTime(new Date(scope.row.PlanStartTime), 'yyyy-MM-dd') : ''}}
            </template>
          </el-table-column>
          <el-table-column prop='PlanEndTime' label='计划完工日期' width='100'>
            <template #default='scope'>
              {{scope.row.PlanEndTime ? dateTimeUtil.formartDateTime(new Date(scope.row.PlanEndTime), 'yyyy-MM-dd') : ''}}
            </template>
          </el-table-column>
          <el-table-column prop='PlanMachineNumber' label='计划设备编号' width='120'>
          </el-table-column>
          <el-table-column prop='PlanMachineName' label='计划设备名称' width='120'>
          </el-table-column>
          <el-table-column prop='PlanEmployeName' label='计划职员' width='100'>
          </el-table-column>
          <el-table-column label='操作' width='80' fixed='right'>
            <template #default='scope'>
              <el-tooltip effect='dark' content='编辑' placement='top-start' v-if='scope.row.Status === "0" || scope.row.Status === "1"'>
                <el-button type='primary' circle style='padding: 4px;' @click='showEditICMOEntryDialogMD(scope)'><i class='sys sys-edit'></i></el-button>
              </el-tooltip>
              <el-tooltip effect='dark' content='撤销下达' placement='top-start' v-if='scope.row.Status === "2" && showCancelICMOReleasePower'>
                <el-button type='danger' circle style='padding: 4px;' @click='cancelICMOEntryRelease(scope)'><i class='sys sys-cancel'></i></el-button>
              </el-tooltip>
              <el-tooltip effect='dark' content='删除' placement='top-start' v-if='scope.row.Status === "0" || scope.row.Status === "1"'>
                <el-button type='danger' circle style='padding: 4px;' @click='deleteICMOEntry(scope)'><i class='sys sys-delete'></i></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='dialogButtomCenterBtn' style='margin-top: 5px;'>
        <el-button type='primary' @click='showAddICMOEntryDialogMD()' size='mini'>添加</el-button>
        <el-button @click='showICMOReleaseDialog = false' size='mini'>取消</el-button>
      </div>

      <!-- 添加工单 -->
      <el-dialog v-dialogDrag title='添加工单' :visible.sync='showAddICMOEntryDialog'
        width='350px' top='10px' lock-scroll append-to-body>
        <div style='margin-top: -30px;'>
          <div style='height: 30px;'>
            <div class='inputField-label' style='width: 85px; text-align: left'>
              生产任务单号
            </div>
            <el-input v-model='icmoEntry.BillNo' disabled class='inputField-input'
              size='mini' style='width: 205px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              工单号
            </div>
            <el-input v-model='icmoEntry.DetailNo' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              物料代码
            </div>
            <el-input v-model='icmoEntry.ItemNumber' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              物料名称
            </div>
            <el-input v-model='icmoEntry.ItemName' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              数量
            </div>
            <el-input-number v-model='icmoEntry.Qty' class='inputField-input' @change='editICMOEntryQtyChange'
              size='mini' style='width: 230px;'>
            </el-input-number>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              单位
            </div>
            <el-input v-model='icmoEntry.UnitName' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划开始
            </div>
            <el-date-picker v-model='icmoEntry.PlanStartTime' class='inputField-input' value-format='yyyy-MM-dd'
              size='mini' style='width: 230px;'>
            </el-date-picker>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划结束
            </div>
            <el-date-picker v-model='icmoEntry.PlanEndTime' class='inputField-input' value-format='yyyy-MM-dd'
              size='mini' style='width: 230px;'>
            </el-date-picker>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划设备
            </div>
            <el-select v-model='icmoEntry.PlanMachineID' placeholder='请选择'
              class='inputField-input'
              style='width: 230px;' size='mini'>
              <el-option v-for='machine in machines'
                :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
              </el-option>
            </el-select>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划职员
            </div>
            <el-select v-model='icmoEntry.PlanEmployeeID' placeholder='请选择'
              class='inputField-input'
              style='width: 230px;' size='mini'>
              <el-option v-for='employee in employees'
                :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
              </el-option>
            </el-select>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              末道工序
            </div>
            <el-select v-model='icmoEntry.LastRoutingFlag' placeholder='请选择'
              class='inputField-input' :clearable='false'
              style='width: 230px;' size='mini'>
              <el-option v-for='yesorno in yesornos'
                :key='yesorno.code' :label='yesorno.name' :value='yesorno.code'>
              </el-option>
            </el-select>
          </div>
          <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
            <el-button type='primary' @click='addICMOEntryAndRelease()' size='mini' v-if='showIcmoReleasePower'>添加并下达</el-button>
            <el-button type='primary' @click='addICMOEntry()' size='mini'>添加</el-button>
            <el-button @click='showAddICMOEntryDialog = false' size='mini'>取消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 编辑工单 -->
      <el-dialog v-dialogDrag :title='"编辑工单" + icmoEntry.DetailNo' :visible.sync='showEditICMOEntryDialog'
        width='350px' top='10px' lock-scroll append-to-body>
        <div style='margin-top: -30px;'>
          <div style='height: 30px;'>
            <div class='inputField-label' style='width: 85px; text-align: left'>
              生产任务单号
            </div>
            <el-input v-model='icmoEntry.BillNo' disabled class='inputField-input'
              size='mini' style='width: 205px;'>
            </el-input>
          </div>
          <!-- <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              工单号
            </div>
            <el-input v-model='icmoEntry.DetailNo' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div> -->
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              物料代码
            </div>
            <el-input v-model='icmoEntry.ItemNumber' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              物料名称
            </div>
            <el-input v-model='icmoEntry.ItemName' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              数量
            </div>
            <el-input-number v-model='icmoEntry.Qty' class='inputField-input' @change='editICMOEntryQtyChange'
              size='mini' style='width: 230px;'>
            </el-input-number>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              单位
            </div>
            <el-input v-model='icmoEntry.UnitName' disabled class='inputField-input'
              size='mini' style='width: 230px;'>
            </el-input>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划开始
            </div>
            <el-date-picker v-model='icmoEntry.PlanStartTime' class='inputField-input' value-format='yyyy-MM-dd'
              size='mini' style='width: 230px;'>
            </el-date-picker>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划结束
            </div>
            <el-date-picker v-model='icmoEntry.PlanEndTime' class='inputField-input' value-format='yyyy-MM-dd'
              size='mini' style='width: 230px;'>
            </el-date-picker>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划设备
            </div>
            <el-select v-model='icmoEntry.PlanMachineID' placeholder='请选择'
              class='inputField-input'
              style='width: 230px;' size='mini'>
              <el-option v-for='machine in machines'
                :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
              </el-option>
            </el-select>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              计划职员
            </div>
            <el-select v-model='icmoEntry.PlanEmployeeID' placeholder='请选择'
              class='inputField-input'
              style='width: 230px;' size='mini'>
              <el-option v-for='employee in employees'
                :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
              </el-option>
            </el-select>
          </div>
          <div style='margin-top: 10px; height: 30px;'>
            <div class='inputField-label' style='width: 60px; text-align: left'>
              末道工序
            </div>
            <el-select v-model='icmoEntry.LastRoutingFlag' placeholder='请选择'
              class='inputField-input' :clearable='false'
              style='width: 230px;' size='mini'>
              <el-option v-for='yesorno in yesornos'
                :key='yesorno.code' :label='yesorno.name' :value='yesorno.code'>
              </el-option>
            </el-select>
          </div>
          <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
            <el-button type='primary' @click='editICMOEntryAndRelease()' size='mini' v-if='showIcmoReleasePower'>保存并下达</el-button>
            <el-button type='primary' @click='editICMOEntry()' size='mini'>保存</el-button>
            <el-button @click='showEditICMOEntryDialog = false' size='mini'>取消</el-button>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'
import { Loading } from 'element-ui'
import sysNumber from '@/components/sys/Number'

export default {
  name: 'ICMORelease',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PM_ICMO_3',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showICMOReleaseDialog: false,
      icmoRow: {},
      icmoEntrys: [],

      showEditICMOEntryDialog: false,
      icmoEntry: {
        InterID: '',
        DetailNo: '',
        BillNo: '',
        ItemNumber: '',
        ItemName: '',
        Qty: '',
        PlanMachineID: '',
        PlanMachineNumber: '',
        PlanMachineName: '',
        PlanEmployeeID: '',
        PlanEmployeeName: '',
        PlanStartTime: '',
        PlanEndTime: '',
        RoutingID: '',
        LastRoutingFlag: '',
        ICMOEntryType: '',
        Status: ''
      },
      editIndex: -1,
      statuss: [],
      machines: [],
      employees: [],
      yesornos: [],

      showAddICMOEntryDialog: false,

      showReleasePower: false,
      showCancelReleasePower: false,
      showIcmoReleasePower: false,
      showCancelICMOReleasePower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.statuss = code.getCode(codes, 'PM_ICMOEntry_Status')
    that.yesornos = code.getCode(codes, 'SYS_YesOrNo')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const employeesPromise = table.getTableContent('BD_Employee', 10000, 1, '', " AND Deleted='0'")
    const machinesPromise = table.getTableContent('BD_Machine', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const employeesObj = await employeesPromise
    const machinesObj = await machinesPromise

    that.employees = employeesObj.tableContent
    that.machines = machinesObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.ReleaseStatus === '2') {
        return { 'background-color': '#9AFF9A' }
      } else if (data.row.ReleaseStatus === '1') {
        return { 'background-color': 'orange' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 直接下推
    batchRelease: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请先选择生产任务单')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].ReleaseStatus !== '0') {
          that.$message.error('请选择未下推的生产任务单！')
          return
        }
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.ICMOBatchRelease', {
        rows: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        if (rtnObj.msg) {
          that.$message.warning('下推成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('下推成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 撤销批量下推
    cancelBatchRelease: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请先选择生产任务单')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].ReleaseStatus === '0') {
          that.$message.error('请选择已下推的生产任务单！')
          return
        }
      }
      that.$confirm('确定要撤销下推这些生产任务单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelICMOBatchRelease', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('撤销成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 撤销下推
    cancelRelease: function (scope) {
      const that = this
      if (scope.data.row.ReleaseStatus === '0') {
        that.$message.error('请选择已下推的生产任务单！')
        return
      }
      that.$confirm('确定要撤销下推该生产任务单【' + scope.data.row.BillNo + '】吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelICMOBatchRelease', {
          rows: [scope.data.row]
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('撤销成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 下推弹出框显示方法
    showICMOReleaseDialogMD: function (scope) {
      const that = this
      that.icmoRow = scope.data.row
      that.icmoEntrys = [].concat(scope.data.row.detailDt1)
      that.showICMOReleaseDialog = true
    },

    // 表格单元格样式
    icmoEntrysCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    icmoEntrysHeaderCellStyle: function () {
      return { padding: '0px', 'background-color': '#f5f7fa' }
    },

    // 表格行样式
    icmoEntrysRowStyle: function (data, rowIndex) {
      if (data.row.Status === '1') {
        return { 'background-color': 'orange' }
      } else if (data.row.Status === '2') { // 淡蓝色
        return { 'background-color': '#CAE1FF' }
      } else if (data.row.Status === '3') { // 淡绿色
        return { 'background-color': '#C1FFC1' }
      } else if (data.row.Status === '4') { // 淡绿色
        return { 'background-color': '#C1FFC1' }
      } else if (data.row.Status === '5') { // 红色
        return { 'background-color': '#FF6A6A' }
      } else if (data.row.Status === '6') { // 淡灰色
        return { 'background-color': '#AAAAAA' }
      } else if (data.row.Status === '8') { // 灰色
        return { 'background-color': '#CCCCCC' }
      } else if (data.row.Status === '9') { // 灰色
        return { 'background-color': '#CCCCCC' }
      } else {
        return {}
      }
    },

    // 下推工单删除
    deleteICMOEntry: async function (scope) {
      const that = this
      that.$confirm('确定要删除该工单【' + scope.row.DetailNo + '】吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.DeleteICMOEntry', {
          rows: [scope.row]
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.icmoEntrys.splice(scope.$index, 1)
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 编辑工单弹出框显示方法
    showEditICMOEntryDialogMD: function (scope) {
      const that = this
      that.icmoEntry = Object.assign({}, scope.row)
      that.editIndex = scope.$index
      that.showEditICMOEntryDialog = true
    },

    // 编辑工单数量改变方法
    editICMOEntryQtyChange: function () {
      const that = this
      try {
        that.icmoEntry.Qty = parseFloat(that.icmoEntry.Qty)
      } catch {
        that.icmoEntry.Qty = 0
      }
      if (isNaN(that.icmoEntry.Qty)) {
        that.icmoEntry.Qty = 0
      }
      if (that.icmoEntry.Qty < 0) {
        that.icmoEntry.Qty = 0
      }
    },

    // 保存工单并下达
    editICMOEntryAndRelease: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.EditICMOEntryAndRelease', {
        icmoEntry: that.icmoEntry
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showEditICMOEntryDialog = false
        that.icmoEntrys[that.editIndex].Status = '2'
        that.icmoEntrys[that.editIndex].PlanStartTime = that.icmoEntry.PlanStartTime
        that.icmoEntrys[that.editIndex].PlanEndTime = that.icmoEntry.PlanEndTime
        that.icmoEntrys[that.editIndex].PlanMachineID = that.icmoEntry.PlanMachineID
        that.icmoEntrys[that.editIndex].PlanMachineNumber = ''
        that.icmoEntrys[that.editIndex].PlanMachineName = ''
        for (let i = 0; i < that.machines.length; i++) {
          if (that.machines[i].ID === that.icmoEntry.PlanMachineID) {
            that.icmoEntrys[that.editIndex].PlanMachineNumber = that.machines[i].Number
            that.icmoEntrys[that.editIndex].PlanMachineName = that.machines[i].Name
            break
          }
        }
        that.icmoEntrys[that.editIndex].PlanEmployeeID = that.icmoEntry.PlanEmployeeID
        that.icmoEntrys[that.editIndex].PlanEmployeeName = ''
        for (let i = 0; i < that.employees.length; i++) {
          if (that.employees[i].EmployeeID === that.icmoEntry.PlanEmployeeID) {
            that.icmoEntrys[that.editIndex].PlanEmployeeName = that.employees[i].Name
            break
          }
        }
        that.icmoEntrys[that.editIndex].Qty = that.icmoEntry.Qty
        that.icmoEntrys[that.editIndex].LastRoutingFlag = that.icmoEntry.LastRoutingFlag
        that.icmoEntrys[that.editIndex].ICMOEntryType = that.icmoEntry.ICMOEntryType
        that.$message.success('保存下达成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 保存工单
    editICMOEntry: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.EditICMOEntry', {
        icmoEntry: that.icmoEntry
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showEditICMOEntryDialog = false
        that.icmoEntrys[that.editIndex].PlanStartTime = that.icmoEntry.PlanStartTime
        that.icmoEntrys[that.editIndex].PlanEndTime = that.icmoEntry.PlanEndTime
        that.icmoEntrys[that.editIndex].PlanMachineID = that.icmoEntry.PlanMachineID
        that.icmoEntrys[that.editIndex].PlanMachineNumber = ''
        that.icmoEntrys[that.editIndex].PlanMachineName = ''
        for (let i = 0; i < that.machines.length; i++) {
          if (that.machines[i].ID === that.icmoEntry.PlanMachineID) {
            that.icmoEntrys[that.editIndex].PlanMachineNumber = that.machines[i].Number
            that.icmoEntrys[that.editIndex].PlanMachineName = that.machines[i].Name
            break
          }
        }
        that.icmoEntrys[that.editIndex].PlanEmployeeID = that.icmoEntry.PlanEmployeeID
        that.icmoEntrys[that.editIndex].PlanEmployeeName = ''
        for (let i = 0; i < that.employees.length; i++) {
          if (that.employees[i].EmployeeID === that.icmoEntry.PlanEmployeeID) {
            that.icmoEntrys[that.editIndex].PlanEmployeeName = that.employees[i].Name
            break
          }
        }
        that.icmoEntrys[that.editIndex].Qty = that.icmoEntry.Qty
        that.icmoEntrys[that.editIndex].LastRoutingFlag = that.icmoEntry.LastRoutingFlag
        that.icmoEntrys[that.editIndex].ICMOEntryType = that.icmoEntry.ICMOEntryType
        that.$message.success('保存成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 工单撤销下达
    cancelICMOEntryRelease: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelICMOEntryRelease', {
        rows: [scope.row]
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.icmoEntrys[scope.$index].Status = '1'
        that.$message.success('撤销下达成功')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 添加工单弹出框显示方法
    showAddICMOEntryDialogMD: async function () {
      const that = this
      that.icmoEntry = {
        InterID: that.icmoRow.InterID,
        DetailNo: '',
        BillNo: that.icmoRow.BillNo,
        ItemNumber: that.icmoRow.ItemNumber,
        ItemName: that.icmoRow.ItemName,
        Qty: '',
        PlanMachineID: '',
        PlanMachineNumber: '',
        PlanMachineName: '',
        PlanEmployeeID: '',
        PlanEmployeeName: '',
        PlanStartTime: '',
        PlanEndTime: '',
        RoutingID: '',
        LastRoutingFlag: '1',
        ICMOEntryType: '0',
        Status: '0'
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      that.icmoEntry.DetailNo = await sysNumber.getNumber('PM_ICMOEntry_DetailNo')
      loadingInstance.close()
      that.showAddICMOEntryDialog = true
    },

    // 添加工单并下达
    addICMOEntryAndRelease: async function () {
      const that = this
      if (!that.icmoEntry.Qty || that.icmoEntry.Qty <= 0) {
        that.$message.error('请输入数量！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.AddICMOEntryAndRelease', {
        icmoEntry: that.icmoEntry
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showAddICMOEntryDialog = false
        that.icmoEntry.PlanMachineNumber = ''
        that.icmoEntry.PlanMachineName = ''
        that.icmoEntry.Status = '2'
        for (let i = 0; i < that.machines.length; i++) {
          if (that.machines[i].ID === that.icmoEntry.PlanMachineID) {
            that.icmoEntry.PlanMachineNumber = that.machines[i].Number
            that.icmoEntry.PlanMachineName = that.machines[i].Name
            break
          }
        }
        that.icmoEntry.PlanEmployeeName = ''
        for (let i = 0; i < that.employees.length; i++) {
          if (that.employees[i].EmployeeID === that.icmoEntry.PlanEmployeeID) {
            that.icmoEntry.PlanEmployeeName = that.employees[i].Name
            break
          }
        }
        that.icmoEntrys.push(that.icmoEntry)
        that.$message.success('添加下达成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 添加工单
    addICMOEntry: async function () {
      const that = this
      if (!that.icmoEntry.Qty || that.icmoEntry.Qty <= 0) {
        that.$message.error('请输入数量！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.AddICMOEntry', {
        icmoEntry: that.icmoEntry
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showAddICMOEntryDialog = false
        that.icmoEntry.PlanMachineNumber = ''
        that.icmoEntry.PlanMachineName = ''
        that.icmoEntry.Status = '0'
        for (let i = 0; i < that.machines.length; i++) {
          if (that.machines[i].ID === that.icmoEntry.PlanMachineID) {
            that.icmoEntry.PlanMachineNumber = that.machines[i].Number
            that.icmoEntry.PlanMachineName = that.machines[i].Name
            break
          }
        }
        that.icmoEntry.PlanEmployeeName = ''
        for (let i = 0; i < that.employees.length; i++) {
          if (that.employees[i].EmployeeID === that.icmoEntry.PlanEmployeeID) {
            that.icmoEntry.PlanEmployeeName = that.employees[i].Name
            break
          }
        }
        that.icmoEntrys.push(that.icmoEntry)
        that.$refs.icmoEntrysTable.doLayout()
        that.$message.success('添加成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
</style>
